import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';
import CAT1000 from '../../Tables/Tabledata/OEMMaintenance/AdderView CATx 1000, 16-Ports 2 files 54 Pages/MAN-AVX1008-AVX1016-ADDER 52 Pages.PDF';
import X200 from '../../Tables/Tabledata/OEMMaintenance/AdderView X200 Reciever 2 Files 21 Pages/MAN-X200-EXTENDER_0 19 Pages.PDF';
import AllenBradley from '../../Tables/Tabledata/OEMMaintenance/Allen Bradley/1756-um543_-en-p.pdf';
import AlliedVision from '../../Tables/Tabledata/OEMMaintenance/AlliedVision/Alvium-USB-Cameras_User-Guide 235 Pages.pdf';
import Fuji from '../../Tables/Tabledata/OEMMaintenance/Fuji/HF-XA-5M_OperationManual 2 Pages.pdf';
import DL3801 from '../../Tables/Tabledata/OEMMaintenance/Hewlett Packard/HPE ProLiant DL380 Gen10 Server-a00008180enw.pdf';
import DL3802 from '../../Tables/Tabledata/OEMMaintenance/Hewlett Packard/HPE_a00019109en_us_HPE ProLiant DL380 Gen10 Server User Guide.pdf';
import TripLite1 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-753912-1 page.pdf';
import TripLite2 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-753913-16 pages.pdf';
import TripLite3 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-867789- 44 Pages.pdf';
import TripLite4 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-890217-160 Pages.pdf';
import TripLite5 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-894513- 8 Pages.pdf';

import InovisionManual from '../../Tables/Tabledata/Stellantis_Smart_Inspect_UserManual Rev2.pdf';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 10,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Manufacturer</th>
					<th>Document Description</th>
					<th>Section / Page</th>
					<td>File</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Inovision</td>
					<td>SMARTInspect Manual</td>
					<td>Stellantis_Smart_Inspect_UserManual Rev2.pdf</td>
					<td>
						<a href={InovisionManual} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Adder</td>
					<td>AdderView CATx 1000 – User Guide</td>
					<td>MAN-AVX1008-AVX1016-ADDER 52 Pages.PDF</td>
					<td>
						<a href={CAT1000} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Adder</td>
					<td>Adder X200 Extender – User Guide</td>
					<td>MAN-X200-EXTENDER_0 19 Pages.PDF</td>
					<td>
						<a href={X200} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Allen Bradley</td>
					<td>ControlLogix 5580 and GuardLogix 5580 Controllers – User Manual</td>
					<td>1756-um543_-en-p.pdf</td>
					<td>
						<a href={AllenBradley} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Allied Vision</td>
					<td>Alvium USB Cameras – User Guide</td>
					<td>1756-um543_-en-p.pdf</td>
					<td>
						<a href={AlliedVision} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>CAT1000 Film</td>
					<td>CAT1000non Lens – Operation Manual</td>
					<td>HF-XA-5M_OperationManual 2 Pages.pdf</td>
					<td>
						<a href={Fuji} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Hewlett Packard</td>
					<td>HPE ProLiant DL380 Gen10 Server – QuickSpecs Overview</td>
					<td>HPE ProLiant DL380 Gen10 Server-a00008180enw.pdf</td>
					<td>
						<a href={DL3801} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Hewlett Packard</td>
					<td>HPE ProLiant DL380 Gen10 Server User Guide</td>
					<td>HPE_a00019109en_us_HPE ProLiant DL380 Gen10 Server User Guide.pdf</td>
					<td>
						<a href={DL3802} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trip-Lite - Eaton</td>
					<td>Hardwiring the SU6000XFMR2U to the UPS PDU (SU6000RT4UTFHW) – Addendum</td>
					<td>Tripp-Lite-Owners-Manual-753912-1 page.pdf</td>
					<td>
						<a href={TripLite1} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trip-Lite - Eaton</td>
					<td>SmartOnline® Series 6kVA Isolation/Step-Down Transformer Module – Owner’s Manual</td>
					<td>Tripp-Lite-Owners-Manual-753913-16 pages.pdf</td>
					<td>
						<a href={TripLite2} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trip-Lite - Eaton</td>
					<td>SmartOnline® UPS System with Step-Down Isolation Transformers – Addendum</td>
					<td>Tripp-Lite-Owners-Manual-867789- 44 Pages.pdf</td>
					<td>
						<a href={TripLite3} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trip-Lite - Eaton</td>
					<td>SmartOnline® Single-Phase Rack-Mount Online UPS with Built-in LCD Monitoring, Control Screen and Detachable Bypass Power Distribution Module – Owner’s Manual</td>
					<td>Tripp-Lite-Owners-Manual-890217-160 Pages.pdf</td>
					<td>
						<a href={TripLite4} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trip-Lite - Eaton</td>
					<td>SNMP/Web Management Accessory Card – Owner’s Manual SNMP/Web Management Accessory Card – Owner’s Manual</td>
					<td>Tripp-Lite-Owners-Manual-894513- 8 Pages.pdf</td>
					<td>
						<a href={TripLite5} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="10">
							10
						</option>
						<option value="20">20</option>
						<option value="30">30</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const Table = styled(TableComp)``;

export default Table;
